import React from "react";
import "./ProfileBanner.css"; // Import the CSS file
import silhouette from "../../images/headshot-silhouette-30.png";
import arrow from "../../images/arrow.png";

interface ProfileBannerProps {
  name: string;
  role: string;
  profile_pic: string;
}

const ProfileBanner: React.FC<ProfileBannerProps> = ({
  name,
  role,
  profile_pic,
}) => {
  const handleButtonClick = () => {
    alert("Button clicked!");
  };

  return (
    <div className="dashboard-profile-banner-wrapper">
      <div className="dashboard-profile-banner-header">Dashboard</div>
      <div className="dashboard-profile-banner-container">
        <div className="dashboard-profile-banner-circle-container">
          <div className="dashboard-profile-banner-outer-circle">
            <div className="dashboard-profile-banner-inner-circle">
              <img
                src={profile_pic || silhouette}
                alt="Profile"
                className="dashboard-profile-banner-profile-picture"
                onError={(e) => {
                  e.currentTarget.src = silhouette;
                }}
              />
            </div>
          </div>
        </div>
        <div className="dashboard-profile-banner-text-container">
          <div className="dashboard-profile-banner-large-text">{name}</div>
          <div className="dashboard-profile-banner-small-text">{role}</div>
        </div>
        <div className="dashboard-profile-banner-right-container">
          {/* <button
            className="dashboard-profile-banner-action-button"
            onClick={handleButtonClick}
          >
            Click Me
          </button>
          <div className="dashboard-profile-banner-image-spot">
            <img
              src={arrow}
              alt="Right"
              className="dashboard-profile-banner-right-image"
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ProfileBanner;
